import React from "react";

import { pickPercent } from "./utils";
import OnePanelChart from "./OnePanelChart";
import DivFormula from "./DivFormula";
import Text from "./Text";

const ReturnOnEquity = ({ teams, competitionMetrics }) => (
  <OnePanelChart
    title="Return on Equity"
    vertical
    suffix="%"
    data={pickPercent(teams, competitionMetrics, "ROE")}
    teams={teams}
  >
    <Text>
      Investors use ROE to measure how well a business uses its equity to
      generate net profits. The higher the ROE, the better. Here is the formula:
    </Text>
    <DivFormula name1="ROE" name2="NET PROFITS" name3="AVERAGE TOTAL EQUITY" />
  </OnePanelChart>
);

export default ReturnOnEquity;



// WEBPACK FOOTER //
// ./src/components/analysis/ReturnOnEquity.js